<template>
    <v-dialog v-model="open" persistent max-width="800px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
            >
                {{ activatorText }}
            </v-btn>
        </template>
        <v-form ref="form"
                v-model="validForm"
                lazy-validation
        >
            <!-- Loading -->
            <v-card v-if="formLoading || dataSent">
                <!-- Preloader -->
                <v-card-text v-show="formLoading">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <v-progress-circular
                                    :size="70"
                                    :width="7"
                                    color="primary darken-1"
                                    indeterminate
                            ></v-progress-circular>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- End Preloader -->
                <!-- Success Message -->
                <v-card-text v-show="!formLoading && dataSent">
                    <v-row align="center" justify="center">
                        <v-col cols="12" class="text-center">
                            <span class="message-success-form">{{ successMessage }}</span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- End Success Message -->
            </v-card>
            <!-- Loading -->
            <v-card v-else>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <slot/>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" text @click="handleDialogClose">Close</v-btn>
                    <v-btn color="primary darken-1" :disabled="!validForm" @click="handleFormSubmit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
export default {
  props: [
    'formTitle',
    'successMessage',
    'formLoading',
    'dataSent',
    'activatorText',
    'dialog',
    'valid',
  ],
  data() {
    return {
      open: false,
      validForm: this.valid || true,
    };
  },
  watch: {
    dialog(newVal) {
      this.open = newVal;
    },
    open(newVal) {
      if (newVal) {
        this.$emit('dialogOpen', this.$refs.form);
      }
    },
  },
  methods: {
    handleDialogClose() {
      this.open = false;
      this.$emit('dialogClose', this.$refs.form);
    },
    handleFormSubmit() {
      this.$emit('formSubmit', this.$refs.form);
    },
  },
  name: 'FormDialog',
};
</script>

<style scoped>
</style>
